<template>
  <div>
    <div class="register-form-container">
      <div class="container">
        <div class="register-form-title">
          <img src="../../../Assets/Images/id.png" alt="register icon" />
          <h4 class="generic-form-title">{{ formTitle }}</h4>
        </div>
        <form class="form-container" v-if="isFormVisible" autocomplete="off">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                :class="editProfileMode ? 'input-gray' : ''"
              >
                <input
                  v-model.trim="$v.formData.email.$model"
                  :placeholder="formEmail"
                  type="text"
                  autocomplete="off"
                />
                <p v-if="$v.formData.email.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.email.required"
                    >{{ formEmailRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.email.emailValidation"
                    >{{ formEmailNotValid }}</span
                  >
                </p>
              </div>
            </div>

            <div class="col-md-6 col-sm-12">
              <p class="register-form-disclaimer">{{ formDisclaimer }}</p>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                :class="editProfileMode ? 'input-gray' : ''"
              >
                <input
                  v-model.trim="$v.formData.password.$model"
                  :placeholder="formPassword"
                  type="password"
                  autocomplete="off"
                />
                <p v-if="$v.formData.password.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.password.required"
                    >{{ formPasswordRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.password.passwordValidation"
                    >{{ formPasswordNotValid }}</span
                  >
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                :class="editProfileMode ? 'input-gray' : ''"
              >
                <input
                  v-model.trim="$v.formData.repeatPassword.$model"
                  :placeholder="formRetypePassword"
                  type="password"
                  autocomplete="off"
                />
                <p v-if="$v.formData.repeatPassword.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.repeatPassword.required"
                    >{{ formRetypePasswordRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="
                      !$v.formData.repeatPassword.sameAsPassword &&
                        $v.formData.repeatPassword.required
                    "
                    >{{ formRetypePasswordNotSame }}</span
                  >
                </p>
              </div>
            </div>

            <div class="col-md-6 col-sm-12">
              <label>{{ fromFullNameArabic }}</label>
              <div class="input-fields">
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.firstNameArabic.$model"
                    :placeholder="firstName"
                    type="text"
                  />
                  <p v-if="$v.formData.firstNameArabic.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameArabic.required"
                      >{{ firstNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.firstNameArabic.arabicNameValidation &&
                          $v.formData.firstNameArabic.minLength &&
                          !$v.formData.firstNameArabic.arabicNameValidation &&
                          $v.formData.firstNameArabic.maxLength
                      "
                      >{{ firstNameMustArabic }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameArabic.minLength"
                      >{{ firstNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameArabic.maxLength"
                      >{{ firstNameMaxLength }}</span
                    >
                  </p>
                </div>
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.secondNameArabic.$model"
                    :placeholder="secondName"
                    type="text"
                  />
                  <p v-if="$v.formData.secondNameArabic.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameArabic.required"
                      >{{ secondNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.secondNameArabic.arabicNameValidation &&
                          $v.formData.secondNameArabic.minLength &&
                          !$v.formData.secondNameArabic.arabicNameValidation &&
                          $v.formData.secondNameArabic.maxLength
                      "
                      >{{ secondNameMustArabic }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameArabic.minLength"
                      >{{ secondNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameArabic.maxLength"
                      >{{ secondNameMaxLength }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="input-fields">
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.thirdNameArabic.$model"
                    :placeholder="thirdName"
                    type="text"
                  />
                  <p v-if="$v.formData.thirdNameArabic.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameArabic.required"
                      >{{ thirdNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.thirdNameArabic.arabicNameValidation &&
                          $v.formData.thirdNameArabic.minLength &&
                          !$v.formData.thirdNameArabic.arabicNameValidation &&
                          $v.formData.thirdNameArabic.maxLength
                      "
                      >{{ thirdNameMustArabic }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameArabic.minLength"
                      >{{ thirdNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameArabic.maxLength"
                      >{{ thirdNameMaxLength }}</span
                    >
                  </p>
                </div>
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.fourthNameArabic.$model"
                    :placeholder="fourthName"
                    type="text"
                  />
                  <p v-if="$v.formData.fourthNameArabic.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameArabic.required"
                      >{{ fourthNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.fourthNameArabic.arabicNameValidation &&
                          $v.formData.fourthNameArabic.minLength &&
                          !$v.formData.fourthNameArabic.arabicNameValidation &&
                          $v.formData.fourthNameArabic.maxLength
                      "
                      >{{ fourthNameMustArabic }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameArabic.minLength"
                      >{{ fourthNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameArabic.maxLength"
                      >{{ fourthNameMaxLength }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <label>{{ fromFullNameEnglish }}</label>
              <div class="input-fields">
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.firstNameEnglish.$model"
                    :placeholder="firstName"
                    type="text"
                  />
                  <p v-if="$v.formData.firstNameEnglish.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameEnglish.required"
                      >{{ firstNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.firstNameEnglish.englishnameValidation &&
                          $v.formData.firstNameEnglish.minLength &&
                          !$v.formData.firstNameEnglish.englishnameValidation &&
                          $v.formData.firstNameEnglish.maxLength
                      "
                      >{{ firstNameMustEnglish }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameEnglish.minLength"
                      >{{ firstNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.firstNameEnglish.maxLength"
                      >{{ firstNameMaxLength }}</span
                    >
                  </p>
                </div>
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.secondNameEnglish.$model"
                    :placeholder="secondName"
                    type="text"
                  />
                  <p v-if="$v.formData.secondNameEnglish.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameEnglish.required"
                      >{{ secondNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.secondNameEnglish.englishnameValidation &&
                          $v.formData.secondNameEnglish.minLength &&
                          !$v.formData.secondNameEnglish
                            .englishnameValidation &&
                          $v.formData.secondNameEnglish.maxLength
                      "
                      >{{ secondNameMustEnglish }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameEnglish.minLength"
                      >{{ secondNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.secondNameEnglish.maxLength"
                      >{{ secondNameMaxLength }}</span
                    >
                  </p>
                </div>
              </div>
              <div class="input-fields">
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.thirdNameEnglish.$model"
                    :placeholder="thirdName"
                    type="text"
                  />
                  <p v-if="$v.formData.thirdNameEnglish.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameEnglish.required"
                      >{{ thirdNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.thirdNameEnglish.englishnameValidation &&
                          $v.formData.thirdNameEnglish.minLength &&
                          !$v.formData.thirdNameEnglish.englishnameValidation &&
                          $v.formData.thirdNameEnglish.maxLength
                      "
                      >{{ thirdNameMustEnglish }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameEnglish.minLength"
                      >{{ thirdNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.thirdNameEnglish.maxLength"
                      >{{ thirdNameMaxLength }}</span
                    >
                  </p>
                </div>
                <div class="input-field">
                  <input
                    v-model.trim="$v.formData.fourthNameEnglish.$model"
                    :placeholder="fourthName"
                    type="text"
                  />
                  <p v-if="$v.formData.fourthNameEnglish.$dirty">
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameEnglish.required"
                      >{{ fourthNameRequired }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="
                        !$v.formData.fourthNameEnglish.englishnameValidation &&
                          $v.formData.fourthNameEnglish.minLength &&
                          !$v.formData.fourthNameEnglish
                            .englishnameValidation &&
                          $v.formData.fourthNameEnglish.maxLength
                      "
                      >{{ fourthNameMustEnglish }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameEnglish.minLength"
                      >{{ fourthNameMinLength }}</span
                    >
                    <span
                      class="form-container__error-msg"
                      v-if="!$v.formData.fourthNameEnglish.maxLength"
                      >{{ fourthNameMaxLength }}</span
                    >
                  </p>
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field " :class="editMode ? 'input-gray' : ''">
                <input
                  type="text"
                  v-if="editMode"
                  :value="formData.nationality"
                />
                <multiselect
                  v-if="!editMode"
                  v-model="$v.formData.nationality.$model"
                  :options="nationalityArry"
                  :searchable="true"
                  :close-on-select="true"
                  :show-labels="false"
                  :placeholder="formNationality"
                  :track-by="nationaltyLang"
                  :label="nationaltyLang"
                  @input="getNationalities()"
                >
                    <span slot="noResult">
                      {{formNationalityNotMatch}}
                    </span>
                    <span slot="noOptions">
                      No options available
                    </span>
                </multiselect>
                <p v-if="$v.formData.nationality.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.nationality.required"
                    >{{ formNationalityRequired }}</span
                  >
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                v-if="showNationality"
                :class="editMode ? 'input-gray' : ''"
              >
                <input
                  v-model.trim="$v.formData.nationalID.$model"
                  :placeholder="formNationalityId"
                  type="text"
                />
                <p v-if="$v.formData.nationalID.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.nationalID.required"
                    >{{ formNationalityIdRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.nationalID.nationalIdValidation"
                    >{{ formNationalityIdNotValid }}</span
                  >
                </p>
              </div>
              <div
                class="input-field"
                v-if="!showNationality"
                :class="editMode ? 'input-gray' : ''"
              >
                <input
                  v-model.trim="$v.formData.passportNumber.$model"
                  :placeholder="formNationalityId"
                  type="text"
                />
                <p v-if="$v.formData.passportNumber.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.passportNumber.required"
                    >{{ formNationalityIdRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.passportNumber.passportValidation"
                    >{{ formNationalityIdNotValid }}</span
                  >
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                v-if="showNationality"
                :class="editMode ? 'input-gray' : ''"
              >
                <div class="generic-upload-file">
                  <label for="FileUploader" class="generic-upload-file-label">
                    <input
                      type="file"
                      @change="onFileChange"
                      class="generic-upload-file-input"
                      id="nationalIdUpload"
                    />
                    <span class="upload-file-placeholder">
                      {{ uploadIdPassportText }}
                    </span>
                    <span class="upload-icon">
                      <img src="../../../Assets/Images/upload.png" alt="upload icon" />
                    </span>
                  </label>
                </div>
                <span class="upload-file-info">{{ fileNoteTxt }}</span>
                <p v-if="$v.formData.nationalIdUpload.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.nationalIdUpload.required"
                    >{{ fileRequired }}</span
                  >
                </p>
              </div>
              <div
                class="input-field"
                v-if="!showNationality"
                :class="editMode ? 'input-gray' : ''"
              >
                <div class="generic-upload-file">
                  <label for="FileUploader" class="generic-upload-file-label">
                    <input
                      type="file"
                      @change="onFileChange"
                      class="generic-upload-file-input"
                      id="passportNumberUpload"
                    />
                    <span class="upload-file-placeholder">
                      {{ uploadIdPassportText }}
                    </span>
                    <span class="upload-icon">
                      <img src="../../../Assets/Images/upload.png" alt="upload icon" />
                    </span>
                  </label>
                </div>
                <span class="upload-file-info">{{ fileNoteTxt }}</span>
                <p v-if="$v.formData.passportNumberUpload.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.passportNumberUpload.required"
                    >{{ fileRequired }}</span
                  >
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field" :class="editMode ? 'input-gray' : ''">
                <div class="date-picker">
                  <v-date-picker
                    :locale="{ id: dateLanguage }"
                    :input-props="{ placeholder: birthOfDate, readonly: true }"
                    transition="none"
                    :max-date="maxDate"
                    v-model="formData.dateOfBirth"
                    :popover="{ placement: 'bottom-end', visibility: 'click' }"
                  >
                  </v-date-picker>
                  <img
                    class="datapicker-icon"
                    src="../../../Assets/Images/calendar.png"
                    alt="date-picker icon"
                  />
                </div>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field">
                <input
                  v-model.trim="formData.address"
                  :placeholder="address"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field">
                <input
                  v-model.trim="$v.formData.phoneNumber.$model"
                  :placeholder="phone"
                  type="text"
                />
                <p v-if="$v.formData.phoneNumber.$dirty">
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.phoneNumber.required"
                    >{{ phoneRequired }}</span
                  >
                  <span
                    class="form-container__error-msg"
                    v-if="!$v.formData.phoneNumber.phoneValidation"
                    >{{ phoneNotValid }}</span
                  >
                </p>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div
                class="input-field"
                :class="editProfileMode ? 'input-gray' : ''"
              >
                <div class="generic-upload-file">
                  <label for="FileUploader" class="generic-upload-file-label">
                    <input
                      type="file"
                      @change="onFileChange"
                      class="generic-upload-file-input"
                      id="profilePicture"
                    />
                    <span class="upload-file-placeholder">
                      {{ profilePicText }}
                    </span>
                    <span class="upload-icon">
                      <img src="../../../Assets/Images/upload.png" alt="upload icon" />
                    </span>
                  </label>
                </div>
                <span class="upload-file-info">{{
                  profilePicfileNoteTxt
                }}</span>
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field">
                <input
                  v-model="formData.university"
                  :placeholder="university"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field">
                <input
                  v-model="formData.faculty"
                  :placeholder="faculty"
                  type="text"
                />
              </div>
            </div>
            <div class="col-md-6 col-sm-12">
              <div class="input-field">
                <div class="date-picker">
                  <v-date-picker
                    :locale="{ id: dateLanguage, masks: { L: 'YYYY' } }"
                    :input-props="{
                      placeholder: graduationYear,
                      readonly: true,
                    }"
                    transition="right"
                    :max-date="new Date()"
                    :min-date="formData.dateOfBirth"
                    :masks="masks"
                    v-model="formData.graduationYear"
                    :popover="{ placement: 'bottom-end', visibility: 'click' }"
                  >
                  </v-date-picker>
                  <img
                    class="datapicker-icon"
                    src="../../../Assets/Images/calendar.png"
                    alt="date-picker icon"
                  />
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="radio-btns">
                <label class="radio-btn-title">{{ isRepresentative }}</label>
                <div class="custom-radio">
                  <label class="radio-button-container">
                    <span class="radio-text">{{ formYes }}</span>
                    <input
                      v-model="formData.isRepresentative"
                      type="radio"
                      name="Yes"
                      :value="true"
                    />
                    <span class="radio-button-mark"></span>
                  </label>
                </div>
                <div class="custom-radio">
                  <label class="radio-button-container">
                    <span class="radio-text">{{ formNo }}</span>
                    <input
                      v-model="formData.isRepresentative"
                      type="radio"
                      name="No"
                      :value="false"
                    />
                    <span class="radio-button-mark"></span>
                  </label>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-hidden-section">
                <div class="row">
                  <div
                    class="col-md-6 col-sm-12"
                    v-if="formData.isRepresentative"
                  >
                    <div class="input-field">
                      <input
                        v-model.trim="$v.formData.companyName.$model"
                        :placeholder="companyName"
                        type="text"
                      />
                      <p v-if="$v.formData.companyName.$dirty">
                        <span
                          class="form-container__error-msg"
                          v-if="!$v.formData.companyName.required"
                          >{{ companyNameRequired }}</span
                        >
                      </p>
                    </div>
                  </div>
                  <div class="col-md-6 col-sm-12">
                    <div class="input-field">
                      <input
                        v-model.trim="$v.formData.jobTitle.$model"
                        :placeholder="
                          formData.isRepresentative ? jobTitleAstric : jobTitle
                        "
                        type="text"
                      />
                      <p v-if="$v.formData.jobTitle.$dirty">
                        <span
                          class="form-container__error-msg"
                          v-if="!$v.formData.jobTitle.required"
                          >{{ jobTitleRequired }}</span
                        >
                      </p>
                    </div>
                  </div>
                  <div
                    class="col-md-6 col-sm-12"
                    v-if="formData.isRepresentative"
                  >
                    <div class="input-field">
                      <div class="generic-upload-file">
                        <label
                          for="FileUploader"
                          class="generic-upload-file-label"
                        >
                          <input
                            type="file"
                            @change="onFileChange"
                            class="generic-upload-file-input"
                            id="companyAuthorizationDoc"
                          />
                          <span class="upload-file-placeholder">
                            {{ companyAuthorizationDocText }}
                          </span>
                          <span class="upload-icon">
                            <img src="../../../Assets/Images/upload.png" alt="upload icon" />
                          </span>
                        </label>
                      </div>
                      <span class="upload-file-info">{{ fileNoteTxt }}</span>
                      <p v-if="$v.formData.companyAuthorizationDoc.$dirty">
                        <span
                          class="form-container__error-msg"
                          v-if="!$v.formData.companyAuthorizationDoc.required"
                          >{{ CompanyDocRequired }}</span
                        >
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="form-aggree-recap">
                <div class="input-field">
                  <div class="checkbox">
                    <label class="custom-checkbox">
                      <input
                        v-model.trim="$v.formData.agree.$model"
                        @change="$v.formData.agree.$touch"
                        type="checkbox"
                      />
                      <span class="custom-checkbox__img">
                        <img src="../../../Assets/Images/checked-icon.png" alt="icon" />
                      </span>
                      {{ termsConditions }}
                    </label>
                    <p v-if="$v.formData.agree.$dirty">
                      <span
                        class="form-container__error-msg"
                        v-if="!$v.formData.agree.sameAs"
                        >{{ termsConditionsRequired }}</span
                      >
                    </p>
                  </div>
                </div>

                <div class="input-field">
                  <div class="recaptcha">
                    <vue-recaptcha
                      ref="recaptcha"
                      @verify="onVerify"
                      sitekey="6Ld_Ni8iAAAAAH-qm3r51wGH_hlq3u838770p0pC"
                      :loadRecaptchaScript="true"
                      :language="language"
                    >
                    </vue-recaptcha>

                    <p v-if="$v.formData.recaptcha.$dirty">
                      <span
                        class="form-container__error-msg"
                        v-if="!$v.formData.recaptcha.required"
                        >{{ recaptcha }}</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="submit-btn">
            <button
              class="custom-btn"
              v-if="!editProfileMode"
              @click.prevent="submitRegistration"
            >
              {{ submit }}
            </button>
            <button class="custom-btn"
                    v-if="editProfileMode"
                    @click.prevent="submitEditProfile">
                {{ updateBtnText }}
            </button>
          </div>
          <div class="news-letter__loader" v-if="isLoading">
            <img src="../../../Assets/Images/spinner.svg" alt="EDA Spinner" />
          </div>
        </form>
        <div class="toaster" v-bind:class="{ 'show-toaster': showRegisterMes }">
          {{ formResponseMsg }}
        </div>
        <div class="toaster" v-bind:class="{ 'show-toaster': uploadfileError }">
          {{ fileUploadErrorMsg }}
        </div>
        <div
          class="toaster"
          v-bind:class="{ 'show-toaster': uploadfileTypeError }"
        >
          {{ fileUploadTypeErrorMsg }}
        </div>
      </div>
    </div>
    <otp-component
      v-if="!isFormVisible"
      v-on:childToParent="onChildClick"
      :objOtp="optPage"
    ></otp-component>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import moment from "moment";
import Multiselect from "vue-multiselect";
import VueRecaptcha from "vue-recaptcha";
import Vuelidate from "vuelidate";
import {
  required,
  helpers,
  requiredIf,
  sameAs,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import DatePicker from "v-calendar/lib/components/date-picker.umd";
import nationalityListArry from "../../../Scripts/NationalitiesArabic_English.json";
import "vue-multiselect/dist/vue-multiselect.min.css";
import otpComponent from "../Otp/OTP.vue";
import { Object } from "core-js";
import { key, headers } from "../../../Scripts/genericJSFile.js";

Vue.component("v-date-picker", DatePicker);
Vue.use(Vuelidate);

let baseUrl = document.location.origin;
let apiUrl = baseUrl + "";

let IsArabic = document.getElementsByTagName("body")[0].getAttribute("dir") === "rtl"
const englishnameValidation = helpers.regex("alpha", /^[a-zA-Z]+[a-zA-Z\s]*$/);
const arabicNameValidation = IsArabic ? helpers.regex("alpha", /^[\u0621-\u064A\u0660\s]*$/):false;

const emailValidation = helpers.regex(
  "alpha",
  /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
);
const phoneValidation = helpers.regex("alpha", /^[0-9\+\- \(\)]{10,15}$/);
const passwordValidation = helpers.regex(
  "alpha",
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/
);
const nationalIdValidation = helpers.regex(
  "alpha",
  /^(\u0662|\u0663|2|3)[\u0660-\u06690-9][\u0660-\u06690-9][\u0660-\u06610-1][\u0660-\u06690-9][\u0660-\u06630-3][\u0660-\u06690-9](\u0660\u0661|\u0660\u0662|\u0660\u0663|\u0660\0664|\u0661\u0661|\u0661\u0662|\u0661\u0663|\u0661\u0664|\u0661\u0665|\u0661\u0666|\u0661\u0667|\u0661\u0668|\u0661\u0669|\u0662\u0661|\u0662\u0662|\u0662\u0663|\u0662\u0664|\u0662\u0665|\u0662\u0666|\u0662\u0667|\u0662\u0668|\u0662\u0669|\u0663\u0661|\u0663\u0662|\u0663\u0663|\u0663\u0664|\u0663\u0665|\u0668\u0668|01|02|03|04|11|12|13|14|15|16|17|18|19|21|22|23|24|25|26|27|28|29|31|32|33|34|35|88)[\u0660-\u06690-9]{5}/
);
const passportValidation = helpers.regex(
  "alpha",
  /^(?!^0+$)[a-zA-Z0-9]{3,20}$/
);

export default {
  props: {
    formTitle: {
      type: String,
    },
    submit: {
      type: String,
    },
    isLoginPage: {
      type: Boolean,
    },
    editProfileMode: {
      type: Boolean,
    },
    login: {
      type: String,
    },
    backBtn: {
      type: String,
    },
    homePageUrl: {
      type: String,
    },
    loginPageUrl: {
      type: String,
    },
    userprofileUrl: {
      type: String,
    },
    formEmail: {
      type: String,
    },
    formEmailRequired: {
      type: String,
    },
    formEmailNotValid: {
      type: String,
    },
    formDisclaimer: {
      type: String,
    },
    formPassword: {
      type: String,
    },
    formPasswordRequired: {
      type: String,
    },
    formPasswordNotValid: {
      type: String,
    },
    formRetypePassword: {
      type: String,
    },
    formRetypePasswordRequired: {
      type: String,
    },
    formRetypePasswordNotSame: {
      type: String,
    },
    fromFullNameArabic: {
      type: String,
    },
    fromFullNameEnglish: {
      type: String,
    },
    firstName: {
      type: String,
    },
    secondName: {
      type: String,
    },
    thirdName: {
      type: String,
    },
    fourthName: {
      type: String,
    },
    fourthNameMaxLength: {
      type: String,
    },
    fourthNameMustArabic: {
      type: String,
    },
    fourthNameMustEnglish: {
      type: String,
    },
    fourthNameRequired: {
      type: String,
    },
    fourthNameMinLength: {
      type: String,
    },
    thirdNameMaxLength: {
      type: String,
    },
    thirdNameMustArabic: {
      type: String,
    },
    thirdNameMustEnglish: {
      type: String,
    },
    thirdNameRequired: {
      type: String,
    },
    thirdNameMinLength: {
      type: String,
    },
    secondNameMaxLength: {
      type: String,
    },
    secondNameMustArabic: {
      type: String,
    },
    secondNameMustEnglish: {
      type: String,
    },
    secondNameRequired: {
      type: String,
    },
    secondNameMinLength: {
      type: String,
    },
    firstNameMaxLength: {
      type: String,
    },
    firstNameMustArabic: {
      type: String,
    },
    firstNameMustEnglish: {
      type: String,
    },
    firstNameRequired: {
      type: String,
    },
    firstNameMinLength: {
      type: String,
    },
    formNationality: {
      type: String,
    },
    formNationalityRequired: {
      type: String,
    },
    formNationalityId: {
      type: String,
    },
    formNationalityIdRequired: {
      type: String,
    },
    formNationalityIdNotValid: {
      type: String,
    },
    formNationalityNotMatch: {
      type: String,
    },
    uploadIdPassportTxt: {
      type: String,
    },
    fileNoteTxt: {
      type: String,
    },
    profilePicfileNoteTxt: {
      type: String,
    },
    fileUploadErrorMsg: {
      type: String,
    },
    fileUploadTypeErrorMsg: {
      type: String,
    },
    profilePicTxt: {
      type: String,
    },
    fileRequired: {
      type: String,
    },
    birthOfDate: {
      type: String,
    },
    birthOfDateRequired: {
      type: String,
    },
    address: {
      type: String,
    },
    phone: {
      type: String,
    },
    phoneRequired: {
      type: String,
    },
    phoneNotValid: {
      type: String,
    },
    university: {
      type: String,
    },
    faculty: {
      type: String,
    },
    graduationYear: {
      type: String,
    },
    isRepresentative: {
      type: String,
    },
    formYes: {
      type: String,
    },
    formNo: {
      type: String,
    },
    companyName: {
      type: String,
    },
    companyNameRequired: {
      type: String,
    },
    jobTitle: {
      type: String,
    },
    jobTitleAstric: {
      type: String,
    },
    jobTitleRequired: {
      type: String,
    },
    CompanyDoc: {
      type: String,
    },
    CompanyDocRequired: {
      type: String,
    },
    termsConditions: {
      type: String,
    },
    termsConditionsRequired: {
      type: String,
    },
    recaptcha: {
      type: String,
    },
    OTPScreenTitle: {
      type: String,
    },
    OTPScreenConfirmEmail: {
      type: String,
    },
    OTPScreenVerifyCode: {
      type: String,
    },
    OTPScreenVerifyCodeRequired: {
      type: String,
    },
    OTPScreenVerifyCodeNotValid: {
      type: String,
    },
    HomePage: {
      type: String,
    },
    isForgetPasswordPage: {
      type: Boolean,
    },
    registrationSuccessfully: {
      type: String,
    },
    passwordSuccessMessage: {
      type: String,
    },
    imageUrlDesktop: {
      type: String,
    },
    imageUrlMobile: {
      type: String,
      },
    updateBtnText: {
            type:String,
    }
  },
  components: {
    Multiselect,
    VueRecaptcha,
    otpComponent,
  },
  data() {
    return {
      userInfo: {},
      editMode: null,
      isFormVisible: true,
      isLoading: false,
      formResponseMsg: "",
      showRegisterMes: false,
      isReCaptchaRequired: false,
      uploadfileError: false,
      uploadfileTypeError: false,
      dateLanguage: "en",
      language: "en",
      showNationality: true,
      nationalityArry: nationalityListArry,
      nationaltyObjLang: {
        ar: "natianality_ar",
        en: "nationality_en",
      },
      datePickerObjLang: {
        ar: "ar",
        en: "en",
      },
      nationaltyLang: "",
      uploadIdPassportText: this.uploadIdPassportTxt,
      profilePicText: this.profilePicTxt,
      companyAuthorizationDocText: this.CompanyDoc,
      optPage: {},
      maxDate: "",
      masks: {
        input: "YYYY-MM-DD",
      },
      formData: {
        email: "",
        password: "",
        repeatPassword: "",
        firstNameArabic: "",
        secondNameArabic: "",
        thirdNameArabic: "",
        fourthNameArabic: "",
        firstNameEnglish: "",
        secondNameEnglish: "",
        thirdNameEnglish: "",
        fourthNameEnglish: "",
        nationality: null,
        nationalID: "",
        passportNumber: "",
        nationalIdUpload: "",
        passportNumberUpload: "",
        dateOfBirth: null,
        address: "",
        phoneNumber: "",
        profilePicture: "",
        faculty: "",
        university: "",
        graduationYear: null,
        isRepresentative: false,
        companyName: "",
        jobTitle: "",
        companyAuthorizationDoc: "",
        agree: false,
        recaptcha: null,
      },
    };
  },
  validations: {
    formData: {
      email: {
        required: requiredIf(function() {
          return !this.editProfileMode;
        }),
        emailValidation,
      },
      password: {
        required: requiredIf(function() {
          return !this.editProfileMode;
        }),
        passwordValidation,
      },
      repeatPassword: {
        required: requiredIf(function() {
          return !this.formData.repeatPassword;
        }),
        sameAsPassword: sameAs("password"),
      },
      firstNameArabic: {
        required,
        arabicNameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      secondNameArabic: {
        required,
        arabicNameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      thirdNameArabic: {
        required,
        arabicNameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      fourthNameArabic: {
        required,
        arabicNameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      firstNameEnglish: {
        required,
        englishnameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      secondNameEnglish: {
        required,
        englishnameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      thirdNameEnglish: {
        required,
        englishnameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      fourthNameEnglish: {
        required,
        englishnameValidation,
        maxLength: maxLength(14),
        minLength: minLength(2),
      },
      nationality: {
        required: requiredIf(function() {
          return !this.editMode;
        }),
      },
      nationalID: {
        required: requiredIf(function() {
          return (
            this.showNationality &&
            (!this.formData.nationality ||
              this.formData.nationality != {} ||
              this.formData.nationality != "")
          );
        }),
        nationalIdValidation,
      },
      passportNumber: {
        required: requiredIf(function() {
          return (
            !this.showNationality &&
            (!this.formData.nationality ||
              this.formData.nationality != {} ||
              this.formData.nationality != "")
          );
        }),
        passportValidation,
      },
      nationalIdUpload: {
        required: requiredIf(function() {
          return (
            this.showNationality &&
            (!this.formData.nationality ||
              this.formData.nationality != {} ||
              this.formData.nationality != "")
          );
        }),
      },
      passportNumberUpload: {
        required: requiredIf(function() {
          return (
            !this.showNationality &&
            (!this.formData.nationality ||
              this.formData.nationality != {} ||
              this.formData.nationality != "")
          );
        }),
      },
      phoneNumber: {
        required,
        phoneValidation,
      },
      companyName: {
        required: requiredIf(function() {
          return this.formData.isRepresentative;
        }),
      },
      jobTitle: {
        required: requiredIf(function() {
          return this.formData.isRepresentative;
        }),
      },
      companyAuthorizationDoc: {
        required: requiredIf(function() {
          return this.formData.isRepresentative;
        }),
      },
      agree: {
        sameAs: sameAs(() => true),
      },
      recaptcha: {
        required,
      },
    },
  },
  methods: {
    onFileChange(event) {
      var fileName = event.target.files[0].name;
      var imgFile = event.target.files[0];
      var fileExt;

      if (event.target.id === "profilePicture") {
        fileExt =
          imgFile.type == "image/jpg" ||
          imgFile.type == "image/jpeg" ||
          imgFile.type == "image/png";
      } else {
        fileExt =
          imgFile.type == "image/jpg" ||
          imgFile.type == "image/jpeg" ||
          imgFile.type == "image/png" ||
          imgFile.type == "application/pdf";
      }

      if (!fileExt) {
        this.uploadfileTypeError = true;
        setTimeout(() => (this.uploadfileTypeError = false), 5000);
      } else {
        if (imgFile.size <= 2000000 && fileExt) {
          this.uploadfileError = false;
          if (event.target.id == "nationalIdUpload") {
            this.uploadIdPassportText = fileName;
            this.formData.nationalIdUpload = event.target.files[0];
          } else if (event.target.id == "passportNumberUpload") {
            this.uploadIdPassportText = fileName;
            this.formData.passportNumberUpload = event.target.files[0];
          } else if (event.target.id == "profilePicture") {
            this.profilePicText = fileName;
            this.formData.profilePicture = event.target.files[0];
          } else if (event.target.id == "companyAuthorizationDoc") {
            this.companyAuthorizationDocText = fileName;
            this.formData.companyAuthorizationDoc = event.target.files[0];
          }
        } else {
          this.uploadfileError = true;
          setTimeout(() => (this.uploadfileError = false), 5000);
        }
      }
    },
    onVerify(response) {
      this.formData.recaptcha = response;
      this.isReCaptchaRequired = false;
    },
    getNationalities() {
      this.formData.nationalID = "";
      this.formData.passportNumber = "";
      this.formData.nationalIdUpload = "";
      this.formData.passportNumberUpload = "";
      this.uploadIdPassportText = this.uploadIdPassportTxt;

      if (this.formData.nationality.code === "EG") {
        this.showNationality = true;
      } else {
        this.showNationality = false;
      }
    },
    submitRegistration() {
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        setTimeout(function() {
          document.querySelector(".form-container__error-msg").scrollIntoView({
            behavior: "smooth",
            block: "center",
            inline: "start",
          });
        }, 500);
        return;
      } else if (this.formData.recaptcha == null) {
        this.isReCaptchaRequired = true;
        return;
      } else {
        let lang = "";
        if (
          document.getElementsByTagName("html")[0].getAttribute("dir") === "ltr"
        ) {
          lang = "en";
        } else {
          lang = "ar";
        }
        this.isLoading = true;
        let fullNameArabic = `${this.formData.firstNameArabic}, ${this.formData.secondNameArabic}, ${this.formData.thirdNameArabic}, ${this.formData.fourthNameArabic}`;
        let fullNameEnglish = `${this.formData.firstNameEnglish}, ${this.formData.secondNameEnglish}, ${this.formData.thirdNameEnglish}, ${this.formData.fourthNameEnglish}`;

        let formObj = {
          Language: lang,
          Email: this.formData.email,
          UserName: "",
          Password: this.formData.password,
          FullNameArabic: fullNameArabic,
          FullNameEnglish: fullNameEnglish,
          Nationality: this.formData.nationality.natianality_ar,
          NationalID: this.formData.nationalID,
          PassportNumber: this.formData.passportNumber,
          NationalIdUpload: this.formData.nationalIdUpload,
          PassportNumberUpload: this.formData.passportNumberUpload,
          DateOfBirth: this.formData.dateOfBirth ? moment(this.formData.dateOfBirth).format("YYYY-MM-DD"):'',
          Address: this.formData.address,
          PhoneNumber: this.formData.phoneNumber,
          ProfilePicture: this.formData.profilePicture,
          Faculty: this.formData.faculty,
          University: this.formData.university,
          GraduationYear: this.formData.graduationYear ? moment(this.formData.graduationYear).format("YYYY-MM-DD"):'',
          IsRepresentative: this.formData.isRepresentative,
          CompanyName: this.formData.companyName,
          JobTitle: this.formData.jobTitle,
          CompanyAuthorizationDoc: this.formData.companyAuthorizationDoc,
          Recaptcha: this.formData.recaptcha,
          CopyRights: this.formData.agree,
        };
          if (!formObj.DateOfBirth) {
              formObj.DateOfBirth = "";
          }

          if (!formObj.GraduationYear) {
              formObj.GraduationYear = ""
          }

        this.optPage.userEmail = formObj.Email;

        let form_data = new FormData();
        var objKeysValues = Object.entries(formObj);
        for (var i = 0; i < objKeysValues.length; i++) {
          var itemKey = objKeysValues[i][0];
          var itemValue = objKeysValues[i][1];
          form_data.append(itemKey, itemValue);
        }

        let headers = {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        };

        axios
          .post(`${apiUrl}/Umbraco/Surface/Users/Register`, form_data, headers)
          .then((res) => {
            if (res.data.IsOperationSucceed == true) {
              this.isLoading = false;
              this.isFormVisible = false;
              this.optPage.EdaID = res.data.ProfileID;
            } else {
              this.isLoading = false;
              this.formResponseMsg = res.data.Message;
              this.showRegisterMes = true;
              setTimeout(() => {
                this.showRegisterMes = false;
              }, 5000);
            }
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    submitEditProfile() {
      this.formData.repeatPassword = "P@ssw0rd";
      this.formData.password = "P@ssw0rd";
      this.$v.formData.$touch();
      if (this.$v.formData.$anyError) {
        setTimeout(function() {
          document.querySelector(".form-container__error-msg").scrollIntoView({
              behavior: "smooth",
              block: "center",
            inline: "start",
          });
        }, 500);
        return;
      } else if (this.formData.recaptcha == null) {
        this.isReCaptchaRequired = true;
        return;
      } else {
        let lang = "";
        if (
          document.getElementsByTagName("html")[0].getAttribute("dir") === "ltr"
        ) {
          lang = "en";
        } else {
          lang = "ar";
        }
        this.isLoading = true;
        let fullNameArabic = `${this.formData.firstNameArabic}, ${this.formData.secondNameArabic}, ${this.formData.thirdNameArabic}, ${this.formData.fourthNameArabic}`;
        let fullNameEnglish = `${this.formData.firstNameEnglish}, ${this.formData.secondNameEnglish}, ${this.formData.thirdNameEnglish}, ${this.formData.fourthNameEnglish}`;

        let formObj = {
          Language: lang,
          Email: "",
          UserName: "",
          Password: "",
          FullNameArabic: fullNameArabic,
          FullNameEnglish: fullNameEnglish,
          Nationality: this.formData.nationality,
          NationalID: this.formData.nationalID,
          PassportNumber: this.formData.passportNumber,
          NationalIdUpload: this.formData.nationalIdUpload,
          PassportNumberUpload: this.formData.passportNumberUpload,
          DateOfBirth: this.formData.dateOfBirth ? moment(this.formData.dateOfBirth).format("YYYY-MM-DD"):"",
          Address: this.formData.address,
          PhoneNumber: this.formData.phoneNumber,
          ProfilePicture: this.formData.profilePicture,
          Faculty: this.formData.faculty,
          University: this.formData.university,
          GraduationYear: this.formData.graduationYear ? moment(this.formData.graduationYear).format("YYYY-MM-DD"):"",
          IsRepresentative: this.formData.isRepresentative,
          CompanyName: this.formData.companyName,
          JobTitle: this.formData.jobTitle,
          CompanyAuthorizationDoc: this.formData.companyAuthorizationDoc,
          Recaptcha: this.formData.recaptcha,
          CopyRights: this.formData.agree,
        };


          if (!formObj.DateOfBirth) {
              formObj.DateOfBirth = "";
          }

          if (!formObj.GraduationYear) {
              formObj.GraduationYear = ""
          }

        if (this.userInfo.ApprovedByAdmin == 3) {
          formObj.Nationality = this.formData.nationality.natianality_ar;
        }
        let form_data = formObj;
        if (this.userInfo.ApprovedByAdmin != 1) {
          form_data = new FormData();
          var objKeysValues = Object.entries(formObj);
          for (var i = 0; i < objKeysValues.length; i++) {
            var itemKey = objKeysValues[i][0];
            var itemValue = objKeysValues[i][1];
            if (objKeysValues[i][1] == null) {
              itemValue = "";
            }
            form_data.append(itemKey, itemValue);
          }
        }

        let token = localStorage.getItem("token");
        //if (sessionStorage.getItem("token")) {
        //    token = sessionStorage.getItem("token")
        //} else {
        //    token = localStorage.getItem("token")
        //}
        let headers = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        };

        axios
          .post(
            `${apiUrl}/Umbraco/Surface/Users/UpdateUserProfile`,
            form_data,
            headers
          )
          .then((res) => {
            if (res.data.IsOperationSucceed == true) {
              window.location.href = this.userprofileUrl;
              this.formResponseMsg = res.data.Message;
              this.showRegisterMes = true;
              setTimeout(() => {
                this.showRegisterMes = false;
              }, 2000);
            } else {
              this.isLoading = false;
              this.formResponseMsg = res.data.Message;
              this.showRegisterMes = true;
              setTimeout(() => {
                this.showRegisterMes = false;
              }, 2000);
            }
          })
          .catch(() => {
            this.isLoading = false;
          });
      }
    },
    getUserInfo() {
        let token = localStorage.getItem("token");
        //if (sessionStorage.getItem("token")) {
        //    token = sessionStorage.getItem("token")
        //} else {
        //    token = localStorage.getItem("token")
        //}
      if (token) {
        axios
          .post(
            `${apiUrl}/Umbraco/Surface/Users/GetUserProfile`,
            key,
            headers
          )
          .then((res) => {
            if (res.data.ApprovedByAdmin == 2) {
              this.editMode = true;
            } else {
              this.editMode = false;
            }
            let userInfo = res.data;
            this.userInfo = res.data;
            let fullNameEnglish = userInfo.FullNameEnglish.split(", ");
            let fullNameArabic = userInfo.FullNameArabic.split(", ");
            this.formData = {
              email: userInfo.Email,
              password: "P@ssw0rd",
              repeatPassword: "P@ssw0rd",
              firstNameArabic: fullNameArabic[0],
              secondNameArabic: fullNameArabic[1],
              thirdNameArabic: fullNameArabic[2],
              fourthNameArabic: fullNameArabic[3],
              firstNameEnglish: fullNameEnglish[0],
              secondNameEnglish: fullNameEnglish[1],
              thirdNameEnglish: fullNameEnglish[2],
              fourthNameEnglish: fullNameEnglish[3],
              nationality: userInfo.Nationality,
              nationalID: userInfo.NationalID,
              passportNumber: userInfo.PassportNumber,
              nationalIdUpload: userInfo.NationalIdUpload,
              passportNumberUpload: userInfo.PassportNumberUpload,
              dateOfBirth: moment(userInfo.DateOfBirth),
              address: userInfo.Address,
              phoneNumber: userInfo.PhoneNumber,
              profilePicture: userInfo.ProfilePicture,
              faculty: userInfo.Faculty,
              university: userInfo.University,
              graduationYear: userInfo.GraduationYear ? moment(userInfo.GraduationYear):"",
              isRepresentative: userInfo.IsRepresentative,
              companyName: userInfo.CompanyName,
              jobTitle: userInfo.JobTitle,
              companyAuthorizationDoc: userInfo.CompanyAuthorizationDoc,
              agree: false,
              recaptcha: null,
            };

              if (this.formData.dateOfBirth) {
                  this.formData.dateOfBirth = new Date(this.formData.dateOfBirth);
              } else {
                  this.formData.dateOfBirth = "";
              }

              if (this.formData.graduationYear) {
                  this.formData.graduationYear = new Date(
                      this.formData.graduationYear
                  );
              } else {
                  this.formData.graduationYear = ""
              }

            this.nationalityArry.map((x) => {
              if (x.natianality_ar === this.formData.nationality) {
                if (this.userInfo.ApprovedByAdmin != 2) {
                  this.formData.nationality = x;
                }
                if (x.code === "EG") {
                  this.showNationality = true;
                } else {
                  this.showNationality = false;
                }
              }
            });

            if (userInfo.NationalIdUpload) {
              this.uploadIdPassportText = userInfo.NationalIdUpload;
            }

            if (userInfo.PassportNumberUpload) {
              this.uploadIdPassportText = userInfo.PassportNumberUpload;
            }

            if (userInfo.ProfilePicture) {
              this.profilePicText = userInfo.ProfilePicture;
            }
            if (userInfo.CompanyAuthorizationDoc) {
              this.companyAuthorizationDocText =
                userInfo.CompanyAuthorizationDoc;
            }

            document.querySelector(
              ".register-page-form__loader"
            ).style.display = "none";
          });
      }
    },
    getCookie(cname) {
      var name = cname + "=";
      var decodedCookie = decodeURIComponent(document.cookie);
      var ca = decodedCookie.split(";");
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    onChildClick(value) {
      this.isFormVisible = value;
      document.querySelector(".navbar.navbar-expand-lg").style.display =
        "flex";
      document.querySelector(".breadcrumb-container").style.display = "block";
      document.querySelector(".generic-banner").style.display = "block";
      document.querySelector(".footer").style.display = "block";
      document.querySelector(".register-form-container").style.display =
        "block";
      document.querySelector(".copy-right").style.display = "block";
    },
  },
  watch: {
    'formData.isRepresentative'() {
      if(!this.formData.isRepresentative) {
        this.companyAuthorizationDocText = this.CompanyDoc;
        this.formData.companyAuthorizationDoc = "";
        this.formData.companyName = "";
      }
    }
  },
  beforeMount() {
    if (
      document.getElementsByTagName("body")[0].getAttribute("dir") === "ltr"
    ) {
      this.nationaltyLang = this.nationaltyObjLang.en;
      this.dateLanguage = this.datePickerObjLang.en;
      this.language = this.datePickerObjLang.en;
    } else {
      this.nationaltyLang = this.nationaltyObjLang.ar;
      this.dateLanguage = this.datePickerObjLang.ar;
      this.language = this.datePickerObjLang.ar;
    }
  },
  mounted() {
    let todayDate = new Date();
    let year = todayDate.setFullYear(todayDate.getFullYear() - 16);
    this.maxDate = moment(year).format();
    if (this.editProfileMode) {
      this.getUserInfo();
    } else {
      document.querySelector(".register-page-form__loader").style.display =
        "none";
      this.editMode = false;
    }

    this.optPage = {
      backBtn: this.backBtn,
      userEmail: "",
      EdaID:"",
      loginUrl: this.loginPageUrl,
      homeUrl: this.homePageUrl,
      isLoginPage: this.isLoginPage,
      isForgetPasswordPage: this.isForgetPasswordPage,
      OTPTitle: this.OTPScreenTitle,
      OTPConfirmEmail: this.OTPScreenConfirmEmail,
      OTPVerifyCode: this.OTPScreenVerifyCode,
      OTPVerifyCodeRequired: this.OTPScreenVerifyCodeRequired,
      OTPVerifyCodeNotValid: this.OTPScreenVerifyCodeNotValid,
      submit: this.submit,
      login: this.login,
      home: this.HomePage,
      registeredSuccess: this.registrationSuccessfully,
      passwordSuccess: this.passwordSuccessMessage,
      imgDesktop: this.imageUrlDesktop,
      imgMobile: this.imageUrlMobile,
      isRegister: true,
    };
  },
};
</script>
